import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ex-notifications-action',
  templateUrl: './ex-notifications-action.component.html',
  styleUrls: ['./ex-notifications-action.component.css']
})
export class ExNotificationsActionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/auth/signin/ex-notifications-action/ex-notifications-action.component.ts